import React, { useEffect, useState } from 'react';

export const useFormValidation = (options) => {

    const [formValues, setValues] = useState(options?.initialValues || {});
    const [formErrors, setErrors] = useState({});
    const [details, setDetails] = useState({});
    const [formValid, setFormValid] = useState({ value: options?.validations ? false: true, message: "" });

    useEffect(() => {
        validateForm();
    }, [formErrors]);

    const handleInput = (event, input, sanitize) => {
        const name = input?.name ? input?.name : event && event.target?.name !== undefined ? event.target.name : "";
        const val = input?.value ? input?.value : event && event.target?.value !== undefined ? event.target.value : "";
        const value = sanitize ? sanitize(val) : val.trim();
        const eventType = event && event?.type ? event?.type : '';

        if (eventType == 'blur' && !details[name] && !details[name]?.touched) {
            setDetails({
                ...formValues,
                [name]: {touched: true},
            });
        }
        if (eventType === 'blur' ||
            (formErrors[name] && formErrors[name].value) || (details[name] && details[name]?.touched) || (eventType === '' && input)) {
            validateInput(name, value);
        } 
        
        setValues({
            ...formValues,
            [name]: value,
        });
    }

    const handleForm = (event) => {
        if (event) {
            event.preventDefault();
        }

        const validations = options?.validations;

        if (validations) {
            for (const key in validations) {
                if (key !== 'form') {
                    const value = formValues[key];
                    validateInput(key, value);
                }
            }
        } else {
            setFormValid({
                value: true,
                message: ""
            });
        }

        return validateForm();
    };

    const validateInput = (name, value) => {

        const validations = options?.validations;
        let error = {
            value: false,
            message: ""
        };

        if (validations) {
            const validation = validations[name];
            const required = validation?.required && validation?.required?.value === true;

            // REQUIRED  
            if (required && !value) {
                error = {
                    value: true,
                    message: validation?.required?.message
                };
            }

            // PATTERN  
            const pattern = value ? validation?.pattern : "";
            if (pattern && pattern?.value && !RegExp(pattern.value).test(value)) {
                error = {
                    value: true,
                    message: validation?.pattern?.message
                };
            }

            // CUSTOM  
            const custom = validation?.custom;
            if (custom && custom?.isValid && !custom.isValid(value)) {
                error = {
                    value: true,
                    message: validation?.custom?.message
                };
            }
        } 

        if (!formErrors[name] || (formErrors[name] && ((formErrors[name].value !== error.value) || (formErrors[name].message !== error.message)))) {
            setErrors({
                ...formErrors,
                [name]: error
            });
        }
    }

    const validateForm = () => {
        let isFormValid = true;
        let formValidObj = formValid;
        const validations = options?.validations;

        if (validations) {
            const formValidation = validations['form']?.isValid;
            if (formValidation && !formValidation(formValues, formErrors)) {
                isFormValid = false;
            }

            if (Object.keys(formErrors).length > 0) {
                Object.keys(formErrors).forEach((key) => {
                    if (formErrors[key].value) {
                        isFormValid = false;
                    }
                })
            } else {
                isFormValid = false;
            }
        } 

        if (formValid.value !== isFormValid) {
            const formMessage = isFormValid ? "" : validations['form']?.message ? validations['form']?.message : "";
            formValidObj = {
                value: isFormValid,
                message: formMessage
            };

            setFormValid(formValidObj);
        }

        return formValidObj;
    }

    return {
        formErrors,
        formValid,
        handleForm,
        handleInput,
        formValues
    }
}